import { createFileRoute } from "@tanstack/react-router"

import { ApprovalPanel } from "@/pages/ApprovalPanel"

export const Route = createFileRoute("/operations/approvals")({
  component: ApprovalPanel,
})
